import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Stack } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';
import { SupportedLanguage } from '../../lib/i18n';

// Flag component using flagcdn.com for reliable flag images
const Flag = ({ countryCode, size = 20 }: { countryCode: string; size?: number }) => (
  <img
    src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`}
    srcSet={`https://flagcdn.com/w80/${countryCode.toLowerCase()}.png 2x`}
    width={size}
    height={Math.round(size * 0.75)}
    alt={countryCode}
    style={{ borderRadius: 2, objectFit: 'cover' }}
  />
);

export default function PreferencesSettings() {
  const { t } = useTranslation(['profile', 'common']);
  const { currentLanguage, changeLanguage, supportedLanguages, isChanging } = useLanguage();

  const handleLanguageChange = (event: any) => {
    const newLang = event.target.value as SupportedLanguage;
    changeLanguage(newLang);
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 3 }}>
        {t('profile:preferences.title')}
      </Typography>

      <Stack spacing={4}>
        {/* Language Preference */}
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <LanguageIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {t('profile:preferences.language')}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {t('profile:preferences.languageDesc')}
          </Typography>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="language-select-label">{t('common:language')}</InputLabel>
            <Select
              labelId="language-select-label"
              id="language-select"
              value={currentLanguage}
              label={t('common:language')}
              onChange={handleLanguageChange}
              disabled={isChanging}
            >
              {supportedLanguages.map((lang) => (
                <MenuItem key={lang.code} value={lang.code}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Flag countryCode={lang.flagCode} size={20} />
                    <Typography>{lang.nativeName}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      ({lang.name})
                    </Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Stack>
    </Box>
  );
}

